<!-- SENDER -->
<div *ngIf="msgData.sender;" class="flex justify-content-end flex-wrap">
  <div class="messageBuble receiverBubble mt-2 mr-2 ml-8" pTooltip="{{msgData.msg}}">
    <div class="text-message">
      {{translateMsg(msgData.msg)}}
    </div>
    <span class="flex align-content-end justify-content-end flex-wrap">
      <span class="text-xs messageDateTime">{{msgData?.date ? (msgData?.date | date: 'dd/MM/yyyy HH:mm') : msgData?.date}}</span>
    </span>
  </div>
  <span class="flex align-content-center flex-wrap mr-2">
    <p-avatar label="{{getNameInitials(msgData.author)}}" shape="circle" pTooltip="{{msgData.author}}" />
  </span>
</div>

<!-- NORMAL RESPONSE -->
<div *ngIf="!msgData.sender;" class="flex justify-content-start flex-wrap">
  <div *ngIf="!isMapUrl" class="messageBuble senderBubble mt-2 ml-2 mr-8">
    <div class="text-message-left">
      {{msgData.msg}}
    </div>
    <span class="flex align-content-start justify-content-start flex-wrap ">
      <span class="text-xs messageDateTime">{{msgData.date | date: 'dd/MM/yyyy HH:mm'}}</span>
    </span>
  </div>

  <!-- MAP RESPONSE -->
  <div *ngIf="isMapUrl" class="messageBuble senderBubble mt-2 ml-2 mr-8">
    <div class="text-message-left">
      <span class="flex align-content-start justify-content-start flex-wrap mb-1">
        <a href={{msgData.msg}} target="_blank" rel="noopener noreferrer" class="p-button font-bold">
          <span><i class="pi pi-map-marker mr-1"></i></span>Ver en GoogleMaps
        </a>
      </span>
      <p-tag severity="secondary" value={{msgData.msg}}/>
    </div>
    <span class="flex align-content-start justify-content-start flex-wrap ">
      <span class="text-xs messageDateTime">{{msgData.date | date: 'dd/MM/yyyy HH:mm'}}</span>
    </span>
  </div>
</div>
